import { AfterViewInit, Component, OnInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SwUpdate } from '@angular/service-worker';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { Observable, Observer, Subject, Subscription, fromEvent, interval, merge, of } from 'rxjs';
import { mapTo, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiCallService } from './Services/api-call.service';
import { DataShareService } from './Services/data-share.service';
import { GlobalService } from './Services/global.service';
import { CryptoService } from './Services/crypto.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {

  private unsubscribe$ = new Subject<void>();
  isInternetReload: boolean = false;
  hasUpdate: boolean = false;

  constructor(
    public Global: GlobalService,
    public shareData: DataShareService,
    private renderer: Renderer2,
    private primengConfig: PrimeNGConfig,
    private apiService: ApiCallService,
    public toaster: MessageService,
    public title: Title,
    private swUpdate: SwUpdate,
    private cryptoService: CryptoService
  ) {
    this.monitorNetworkStatus();
  }

  async ngOnInit(): Promise<void> {

    // Check if the current window is not the top window(i.e., inside an iframe)
    if (window !== window.top) {
      // Ensure window.top is not null and handle the Location object properly
      if (window.top) {
        // Use href to assign the location as a string
        window.top.location.href = window.location.href;
      } else {
        // Fallback in case window.top is inaccessible (e.g., cross-origin restrictions)
        window.location.href = window.location.href; // Reload in the current context
      }
    }
    await this.loadCompanyDetails();
    this.primengConfig.ripple = true;
  }

  ngAfterViewInit() {
    let loader = this.renderer.selectRootElement('#pre-loader');
    this.renderer.setStyle(loader, 'display', 'none');
  }

  private async loadCompanyDetails(): Promise<void> {
    this.Global.setHeaderEncryptData(window.location.host);
    const encryptedDomain = await this.cryptoService.encryptAES(window.location.host);
    this.apiService
      .getCompanyDetails({ domain: encryptedDomain })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response: any) => {
        if (response.status) {
          this.updateCompanyDetails(response.data);
        }
      });
  }

  private updateCompanyDetails(data: any): void {
    const colorCodes = data.colorCode.split(',');

    this.Global.companyDetails = {
      companyColorCodes: colorCodes,
      companyId: data.companyId,
      companyTitle: data.pageTitle,
      companyDescription: data.companyDescription,
      companyLogo: `${environment.baseUrl}${environment.imageUrl}${environment.CompanySetting}${data.companyLogo}`,
      companyIcon: `${environment.baseUrl}${environment.imageUrl}${environment.CompanySetting}${data.companyIcon}`,
      companyFavIcon: `${environment.baseUrl}${environment.imageUrl}${environment.CompanySetting}${data.companyFavicon}`,
      companyName: data.title,
    };

    this.Global.setLocalStorage({ key: 'companyId', value: data.companyId });
    this.title.setTitle(`${data.title} | ${data.pageTitle}`);

    const favIcon = document.getElementById('favIcon') as HTMLLinkElement;
    console.log('****** favIcon ******', favIcon);
    console.log('****** this.Global.companyDetails.companyFavIcon ******', this.Global.companyDetails.companyFavIcon);
    favIcon.setAttribute('href', this.Global.companyDetails.companyFavIcon);

    this.shareData.shareData({ function: "isLoadedGetCompanyDetailsApi", data: this.Global.companyDetails })

  }

  private monitorNetworkStatus(): void {
    const online$ = fromEvent(window, 'online').pipe(mapTo(true));
    const offline$ = fromEvent(window, 'offline').pipe(mapTo(false));
    const networkStatus$ = merge(of(navigator.onLine), online$, offline$);

    networkStatus$.subscribe((isOnline: boolean) => {
      if (isOnline) {
        if (this.isInternetReload) {
          this.Global.noInternetConnection = 'onInternet';
          setTimeout(() => {
            window.location.reload(); // Refresh the page
          }, 1000); // Small delay for better user experience
        } else {
          this.Global.noInternetConnection = 'internet';
        }
      } else {
        this.Global.noInternetConnection = 'noInternet';
        this.isInternetReload = true;
      }
    });
  }

  reloadSite(): void {
    // localStorage.clear();
    window.location.reload();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
